import aggiungi from  './aggiungi'

const isAdmin = localStorage.getItem('usera') ? (JSON.parse(atob(localStorage.getItem('usera'))).isAdmin == 1) : false

const baseButton = [
  // always
  {
    'key': 'pdrs-button-aggiungi',
    'label': 'AGGIUNGI CORSO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-plus',
    'type': 'operation',
    'method': aggiungi,
    'display': 'always',
    adminOnly: true
  },
 

]
const finalTabs = baseButton.filter(tab => {
    // Mostra il tab se NON ha la proprietà adminOnly O se l'utente è admin.
    return !tab.adminOnly || isAdmin;
});

// 3. Esporta l'array filtrato.
export default finalTabs;